"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyeFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("circle", { cx: 16, cy: 16, r: 4 }),
        React.createElement("path", { d: "M29.9 13.88C26.67 8.49 21.22 5 16 5S5.33 8.49 2.1 13.88L.84 16l1.26 2.12C5.33 23.51 10.79 27 16 27s10.67-3.49 13.9-8.88L31.17 16zM16 22a6 6 0 116-6 6 6 0 01-6 6z" })));
}
exports.default = SvgEyeFilled;
//# sourceMappingURL=EyeFilled.js.map